type StripeProps = {
  children: string;
  color?: string;
  dark?: boolean;
};

export function Stripe({ children, color = 'var(--orange)', dark = false }: StripeProps) {
  return (
    <div
      style={{
        background: color,
        color: dark ? 'var(--shop-fg)' : 'var(--ink)',
        padding: '5px 0',
        fontFamily: 'var(--display)',
        textTransform: 'uppercase',
        letterSpacing: '.18em',
        fontSize: 11,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      }}
    >
      {Array.from({ length: 8 }).map((_, i) => (
        <span key={i} style={{ paddingRight: 24 }}>
          {children} ✦{' '}
        </span>
      ))}
    </div>
  );
}
